module.exports = __webpack_public_path__ + "img/perforaciones2_4-3_2048.0e9d49d9.webp";